module.exports = import("https://cdn.sheetjs.com/xlsx-0.20.3/package/xlsx.mjs");;